export const types = {
  searchPlanets: '[Planets] Search planet',
  favoriteAdd: '[Plantes] Add favorite planet',
  removeFavorite: '[Plantes] Remove favorite planet',
  listFavorites: '[Plantes] List favorite planets'
}